import { type TaskSummary } from '@/lib/types';
import PortfolioItemCardThumbnailContext from '../../portfolio-item/PortfolioItemCardThumbnail/PortfolioItemCardThumbnailContext';
import PortfolioItemCardThumbnail from '../../portfolio-item/PortfolioItemCardThumbnail';
import { useContext } from 'react';
import ChallengeContext from '../../Challenge/ChallengeView/ChallengeContext';
import { type DraftFunction } from 'use-immer';

export type TaskSummaryWithThumbnail = TaskSummary & {
  thumbnail: NonNullable<TaskSummary['thumbnail']>;
};

type TaskThumbnailProps = {
  task: TaskSummaryWithThumbnail;
};

const TaskThumbnail = ({ task }: TaskThumbnailProps) => {
  const [, setChallenge] = useContext(ChallengeContext);

  const setTaskSummary = (
    stateUpdateFunction: DraftFunction<TaskSummary>,
  ): void => {
    setChallenge(challenge => {
      stateUpdateFunction(challenge.tasks[task.id]);
    });
  };

  const taskApiEndpoint = `challenge-portfolio/tasks/${task.id}`;

  return (
    <PortfolioItemCardThumbnailContext.Provider
      value={{
        portfolioItemSummary: task,
        setPortfolioItemSummary: setTaskSummary,
        portfolioItemApiEndpoint: taskApiEndpoint,
      }}
    >
      <PortfolioItemCardThumbnail />
    </PortfolioItemCardThumbnailContext.Provider>
  );
};

export default TaskThumbnail;
